function invoke(method, config, resolve) {
    const {WeixinJSBridge} = window;
    WeixinJSBridge && WeixinJSBridge.invoke(method, config, resolve);
}

function pay(config,resolve) {
    invoke("getBrandWCPayRequest",config,resolve)
}


export default {pay}